module.exports = __webpack_public_path__ + "img/hr-V-L-3-unload-connect-shadow.23790de9.png";